import JourneyAnalysis from '@/common/models/journeyAnalysis/OldJourneyAnalysis';
import API from '@/org-app/api';
import {
  createDeleteAction,
  createGetAllAction,
  createGetOneAction,
  createPostAction,
  createPutAction,
} from '@/utils/ActionsUtils';

import * as types from './mutation-types';

export default {
  createNewJourneyAnalysis(
    { commit },
    journeyAnalysis = JourneyAnalysis.fromObject({
      id: -1,
    }),
  ) {
    commit(types.CREATE_JOURNEYANALYSIS, journeyAnalysis);
    return journeyAnalysis;
  },
  getJourneyAnalyses: createGetAllAction(
    API.instance.getOldJourneyAnalyses,
    types.UPDATE_JOURNEYANALYSES_LIST,
    'messages.failedToGetJourneyAnalyses',
    true,
  ),
  getOldJourneyAnalysis: createGetOneAction(
    API.instance.getOldJourneyAnalysis,
    types.UPDATE_JOURNEYANALYSIS,
    'messages.failedToGetJourneyAnalysis',
  ),
  createJourneyAnalyses: createPostAction(
    API.instance.postOldJourneyAnalysis,
    types.SAVE_JOURNEYANALYSES,
    'messages.failedToCreateJourneyAnalysis',
  ),
  updateJourneyAnalysis: createPutAction(
    API.instance.putOldJourneyAnalysis,
    types.SAVE_JOURNEYANALYSES,
    'messages.failedToUpdateJourneyAnalysis',
  ),
  deleteJourneyAnalysis: createDeleteAction(
    API.instance.deleteOldJourneyAnalysis,
    types.DELETE_JOURNEYANALYSIS,
    'messages.failedToDeleteJourneyAnalysis',
  ),
  getJourneyAnalysisUnits: createGetAllAction(API.instance.getJourneyAnalysisUnits, null, 'messages.failedToGetUnits'),
};
